import { Badge, Box, Flex, Text } from '@chakra-ui/react'
import { useDraggable } from '@dnd-kit/core'

import { SectionCard } from '../../../components/SectionCard'
import { formatDate } from '../../../helpers'
import { IStudyCreditRequestRowRaw } from '../../../services/StudyCreditRequest/types'
import { EDUCATION_FORMAT_LABELS } from './consts'

interface IStudyCreditKanbanCardProps {
  request: IStudyCreditRequestRowRaw
  dragDisabled: boolean
  onOpen: (id: number) => void
}

interface IStudyCreditKanbanCardContentProps {
  request: IStudyCreditRequestRowRaw
  dragging?: boolean
}

// Presentational card body, shared by the in-place card and the DragOverlay copy.
export function StudyCreditKanbanCardContent({ request, dragging = false }: IStudyCreditKanbanCardContentProps) {
  return (
    // Espalhado e não `borderColor={dragging ? … : undefined}`: um `undefined` explícito ainda
    // sobrescreve a cor da casca e deixa a borda em `currentColor`.
    <SectionCard
      variant="tile"
      w="100%"
      boxShadow={dragging ? 'xl' : 'sm'}
      {...(dragging ? { borderColor: 'magenta.500' } : {})}
    >
      <Flex justify="space-between" align="center" mb={1}>
        <Text variant="label">{request.protocol}</Text>
        <Text variant="caption">{formatDate(request.created_at)}</Text>
      </Flex>
      <Text fontWeight="bold" fontSize="sm" noOfLines={2}>
        {request.student_name}
      </Text>
      <Text variant="caption" noOfLines={1}>
        {request.course?.name}
      </Text>
      <Flex justify="space-between" align="center" mt={2} gap={2}>
        <Text variant="caption" noOfLines={1}>
          {request.consultant?.name}
        </Text>
        <Badge colorScheme="gray" flexShrink={0}>
          {EDUCATION_FORMAT_LABELS[request.education_format]}
        </Badge>
      </Flex>
    </SectionCard>
  )
}

export function StudyCreditKanbanCard({ request, dragDisabled, onOpen }: IStudyCreditKanbanCardProps) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: String(request.id),
    disabled: dragDisabled
  })

  return (
    <Box
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      // The moving copy is rendered by the DragOverlay; keep a dimmed placeholder in place.
      opacity={isDragging ? 0.4 : 1}
      cursor={dragDisabled ? 'pointer' : 'grab'}
      onClick={() => onOpen(request.id)}
    >
      <StudyCreditKanbanCardContent request={request} />
    </Box>
  )
}
